import { render, staticRenderFns } from "./TableSelector.vue?vue&type=template&id=5b50227e&scoped=true&"
import script from "./TableSelector.vue?vue&type=script&lang=js&"
export * from "./TableSelector.vue?vue&type=script&lang=js&"
import style0 from "./TableSelector.vue?vue&type=style&index=0&id=5b50227e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50227e",
  null
  
)

component.options.__file = "TableSelector.vue"
export default component.exports